import { IconTypeAdminNavigation } from "./admin-navigation.type";
import getIconContent from "./admin-navigation.content";
import { ICON_FAMILY_ADMIN_NAVIGATION, ICON_HEIGHT, ICON_WIDTH, } from "./admin-navigation.constants";
class SlhIconFamilyAdminNavigation {
    // eslint-disable-next-line class-methods-use-this
    getIconContent(type) {
        if (Object.values(IconTypeAdminNavigation).includes(type)) {
            return getIconContent(type);
        }
        return undefined;
    }
    // eslint-disable-next-line class-methods-use-this
    getName() {
        return ICON_FAMILY_ADMIN_NAVIGATION;
    }
    // eslint-disable-next-line class-methods-use-this
    getIconWidth() {
        return ICON_WIDTH;
    }
    // eslint-disable-next-line class-methods-use-this
    getIconHeight() {
        return ICON_HEIGHT;
    }
}
export default new SlhIconFamilyAdminNavigation();
